// @core/api/endpoints/secret/list_pki_roles.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListPkiRolesResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * List PKI roles
 * Returns all PKI roles in the engine.
 */
export async function ListPkiRoles(
  engine_id: string,
  params?: {
    limit?: string | number | boolean;
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    sort?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListPkiRolesResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/pki/roles`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  const requestOptions = options;
  return client.get<ListPkiRolesResponse>(requestPath, { ...requestOptions, params });
}
